import React from "react";
import { useFormikContext } from "formik";
import { Banner } from "@jsq/ds/core";
import { useDuplicateInvoiceWarning } from "../../hooks/useDuplicateInvoiceWarning";
import { PayableFormFields, type ClientStepFormValues } from "../../types";

export const DUPLICATE_INVOICE_WARNING_TEXT =
  "This invoice number has been used in a previous entry";

/**
 * Renders a warning banner when the current (arena, payee, invoiceNumber)
 * tuple matches an existing payable on the server. Renders nothing otherwise.
 *
 * Must be mounted inside the ClientStep Formik form so it can read the
 * latest field values via `useFormikContext`.
 */
export const DuplicateInvoiceBanner: React.FC = () => {
  const { values } = useFormikContext<ClientStepFormValues>();

  const { hasDuplicate } = useDuplicateInvoiceWarning({
    arenaId: values[PayableFormFields.ArenaId],
    payeeId: values[PayableFormFields.PayeeId],
    payeeType: values.payeeType,
    invoiceNumber: values[PayableFormFields.InvoiceNumber],
  });

  if (!hasDuplicate) {
    return null;
  }

  return (
    <div data-testid="duplicate-invoice-warning-banner">
      <Banner variant="warning" title={DUPLICATE_INVOICE_WARNING_TEXT} />
    </div>
  );
};

export default DuplicateInvoiceBanner;
